var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-card',{attrs:{"flat":""}},[_c('iframe',{staticStyle:{"display":"block","overflow":"hidden","height":"100vh","width":"100vw"},attrs:{"src":"https://break2000.com/sources/index.php?client=5b7c246d91aa9","frameborder":"0"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }